// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__obQ-T","text":"Input_text__2K1wU","container":"Input_container__Cuc0P","optional":"Input_optional__3IcCS"};